import React from "react";
import "./Home.css";
import Product from "./Product";
import BootstrapCarouselComponent from "./CrouselHome";
import ProductMerged from "./ProductMerged";
function Home() {
  return (
    <>
    <div className="home">
       <div className="home__container">
        <BootstrapCarouselComponent />
        {/* <div className="home__row">
          <Product
            id="12321341"
            title="The Lean Startup: How Constant Innovation Creates Radically Successful Businesses Paperback"
            price={11.96}
            rating={5}
            image="https://m.media-amazon.com/images/I/61h908OnLCL._AC_SY400_.jpg"
          />
          <Product
            id="49538094"
            title="Ruvanti 4 Pcs Full Size Green Bed Sheets, Extra Soft Brushed 1800 Microfiber Sheet Set, Wrinkle Resistant, Breathable, Luxurious, Deep Pocket, Warm, Sheet..."
            price={239.0}
            rating={4}
            image="https://m.media-amazon.com/images/I/5191zZiD2DL._AC_SL1024_.jpg"
          />
        </div> */}

        <div className="home__row">
          <Product
            id="4903850"
            title="Amazon Basics Septic Treatment, 29.4oz Box 3-Pack"
            price={199.99}
            rating={3}
            image="https://m.media-amazon.com/images/I/61cLMGsgunL._AC_UL480_FMwebp_QL65_.jpg"
          />
          <Product
            id="23445930"
            title="Amazon Basics - 128GB microSDXC Memory Card with Full Size Adapter, A2, U3, read speed up to 100 MB/s"
            price={98.99}
            rating={5}
            image="https://m.media-amazon.com/images/I/61ze2Ef7kTL._AC_SL1500_.jpg"
          />
          <Product
            id="3254354345"
            title="Amazon Basics 8-Sheet Cross-Cut Paper and Credit Card Home Office Shredder, Quiet Working with 4.1-Gallon Bin, Black"
            price={598.99}
            rating={4}
            image="https://m.media-amazon.com/images/I/71IywmQMCTL._AC_UL480_FMwebp_QL65_.jpg"
          />
        </div>

        <div className="home__row">
          <Product
            id="90829332"
            title="HP 24mh FHD Monitor - Computer Monitor with 23.8-Inch IPS Display (1080p) - Built-In Speakers and VESA Mounting - Height/Tilt Adjustment for Ergonomic Viewing - HDMI and DisplayPort - (1D0J9AA#ABA)"
            price={1094.98}
            rating={4}
            image="https://m.media-amazon.com/images/I/91fAU6mxFsL._AC_UL480_QL65_.jpg"
          />
        </div>

        <div className="home__row">
         <ProductMerged 
           title="Additional Item to explore"
           image1="https://m.media-amazon.com/images/I/31IMDb6zvPL._AC_SY400_.jpg"
           image2="https://m.media-amazon.com/images/I/31HK9+XV3fL._AC_SY400_.jpg"
           image3="https://m.media-amazon.com/images/I/51ivRBHcH6L._AC_SY400_.jpg"
           image4="https://m.media-amazon.com/images/I/41dNlAqTwWL._AC_SY400_.jpg"
           image5="https://m.media-amazon.com/images/I/41pfjyUPZLL._AC_SY400_.jpg"
           image6="https://m.media-amazon.com/images/I/51ivRBHcH6L._AC_SY400_.jpg"
           image7="https://m.media-amazon.com/images/I/41v9vrW48OL._AC_SY400_.jpg"
           image8="https://m.media-amazon.com/images/I/512SMIvhtPL._AC_SY400_.jpg"
         />
        </div>
      </div>
    </div>
    </>
  );
}

export default Home;